import type { ComponentProps } from "react";
import { t } from "ttag";

import { EmptyState, HeartsIcon } from "@/shared/ui";

export const ErrorState = (props: ComponentProps<typeof EmptyState.Root>) => {
  return (
    <EmptyState.Root {...props}>
      <EmptyState.Icon>
        <HeartsIcon />
      </EmptyState.Icon>

      <EmptyState.Title>{t`Oops, it looks like something went wrong`}</EmptyState.Title>

      <EmptyState.Description className="text-base">
        {t`Please try again, or reach out to support if the issue continues.`}
        <br />
        {t`Thank you for your patience!`}
      </EmptyState.Description>
    </EmptyState.Root>
  );
};
